import React from 'react';
import { Award, Scale, Eye, Clock, MapPin, Radio } from 'lucide-react';
import { usp } from '../data/mock';

export const WhyUs = () => {
  const iconMap = {
    Award: Award,
    Scale: Scale,
    Eye: Eye,
    Clock: Clock,
    MapPin: MapPin,
    Radio: Radio
  };

  return (
    <section id="why-us" className="py-24 bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
            Our Unique Selling Points
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            What sets Unity Group apart in the manpower solutions industry
          </p>
        </div>

        {/* USP Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {usp.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="relative group"
              >
                {/* Card */}
                <div className={`h-full bg-gradient-to-br ${item.gradient} backdrop-blur-sm p-6 rounded-2xl border-2 border-slate-200 hover:border-blue-400 shadow-lg hover:shadow-2xl transition-all duration-300`}>
                  {/* Number Badge */}
                  <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-sm">{index + 1}</span>
                  </div>

                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-white" />
                  </div>

                  {/* Content */}
                  <h3 className="text-lg font-bold text-slate-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-sm">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
